/**
 * The made-up data every example renders over.
 *
 * All of it is local: nothing on the gallery may reach a server, so the page
 * can be opened, tried and screenshotted with no backend and no seed. The
 * names are obviously fictional on purpose - this page is read by the mobile
 * developer and QA, and a plausible organization name would end up in a bug
 * report as though it were real.
 */

/** One row of the sample table: the shape is the gallery's own. */
export interface SampleRow {
  id: string;
  name: string;
  status: 'Active' | 'Draft' | 'Archived';
  supporters: number;
}

export const SAMPLE_ROWS: SampleRow[] = [
  { id: 'row-1', name: 'Clean Rivers Pledge', status: 'Active', supporters: 1284 },
  { id: 'row-2', name: 'Save the Old Library', status: 'Active', supporters: 942 },
  { id: 'row-3', name: 'Bike Lanes Now', status: 'Draft', supporters: 118 },
  { id: 'row-4', name: 'Meadow Restoration', status: 'Active', supporters: 87 },
  { id: 'row-5', name: 'Winter Coat Drive', status: 'Archived', supporters: 2210 },
  { id: 'row-6', name: 'Poll Worker Sign-up', status: 'Draft', supporters: 5 },
];

/**
 * Two audit entries, shaped as the backend sends them - structurally, not by
 * importing the generated types, so nothing here depends on the client.
 */
export const SAMPLE_ACTIVITY = [
  {
    id: 'entry-1',
    action: 'organization.profile_updated',
    occurred_at: '2026-09-24T14:12:00Z',
    actor: {
      kind: 'ORGANIZATION_USER' as const,
      id: 'user-1',
      name: 'Alex Sample',
      email: 'alex@example.org',
    },
    target: { type: 'organization', id: 'org-1', label: 'Sample Organization' },
    organization: { id: 'org-1', name: 'Sample Organization' },
    changes: [
      { field: 'website', before: null, after: 'https://example.org' },
      { field: 'description', before: 'Old words', after: 'New words' },
    ],
  },
  {
    id: 'entry-2',
    action: 'invitation.sent',
    occurred_at: '2026-09-23T09:30:00Z',
    actor: {
      kind: 'ORGANIZATION_USER' as const,
      id: 'user-1',
      name: 'Alex Sample',
      email: 'alex@example.org',
    },
    target: { type: 'portal_user', id: 'user-2', label: 'Sam Invited' },
    organization: { id: 'org-1', name: 'Sample Organization' },
    changes: [],
  },
];

/** A small inline image, so the upload example needs no file and no server. */
export const SAMPLE_IMAGE =
  'data:image/svg+xml;utf8,' +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" width="240" height="120">' +
      '<rect width="240" height="120" fill="#dbe4ee"/>' +
      '<circle cx="60" cy="60" r="34" fill="#5b7fa6"/>' +
      '<text x="120" y="66" font-family="sans-serif" font-size="16" fill="#33475b">Sample</text>' +
      '</svg>',
  );
